// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!./shared.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox {
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  background-color: var(--white);
  border: 0.1rem solid var(--btn-bg-color);
  border-radius: 0.25rem;
  box-sizing: border-box;
  width: 1.25rem;
  height: 1.25rem;
}

.checkbox[aria-checked=true] {
    background-color: var(--btn-bg-color);
  }

.checkbox:hover {
    background-color: var(--theme-color);
  }

.checkbox input {
    position: absolute;
    opacity: 0;
    height: 0;
    width: 0;
  }

.checkbox input:checked ~ .checkmark {
      display: block;
    }

.checkbox .checkmark {
    display: none;
    position: absolute;
    color: var(--white);
    padding-left: 0.1rem;
  }
`, "",{"version":3,"sources":["webpack://./core/components/CheckBox.css"],"names":[],"mappings":"AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;EACjB,8BAA8B;EAC9B,wCAAwC;EACxC,sBAAsB;EACtB,sBAAsB;EACtB,cAAc;EACd,eAAe;AA2BjB;;AAzBE;IACE,qCAAqC;EACvC;;AAEA;IACE,oCAAoC;EACtC;;AAEA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,QAAQ;EAKV;;AAHE;MACE,cAAc;IAChB;;AAGF;IACE,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;EACtB","sourcesContent":["@import \"shared.css\";\r\n\r\n.checkbox {\r\n  position: relative;\r\n  cursor: pointer;\r\n  user-select: none;\r\n  background-color: var(--white);\r\n  border: 0.1rem solid var(--btn-bg-color);\r\n  border-radius: 0.25rem;\r\n  box-sizing: border-box;\r\n  width: 1.25rem;\r\n  height: 1.25rem;\r\n\r\n  &[aria-checked=true] {\r\n    background-color: var(--btn-bg-color);\r\n  }\r\n\r\n  &:hover {\r\n    background-color: var(--theme-color);\r\n  }\r\n\r\n  & input {\r\n    position: absolute;\r\n    opacity: 0;\r\n    height: 0;\r\n    width: 0;\r\n\r\n    &:checked ~ .checkmark {\r\n      display: block;\r\n    }\r\n  }\r\n\r\n  & .checkmark {\r\n    display: none;\r\n    position: absolute;\r\n    color: var(--white);\r\n    padding-left: 0.1rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
